import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { GET_PROJECT_MODEL_DATA_DATE_RANGES } from '../../../query/project/stats/keys';
import {
  getProjectModelDataDateRanges,
  ProjectModelDataDateRange,
} from '../../../services/project/stats/ProjectDailyStatsService';

/**
 * First/last date each model produced data for the project, within the selected range. Used to show
 * an archival model's real data span in the prompts table tooltip. Only fetched when `enabled` (the
 * NEW_STATS preview), since archival models are only surfaced there.
 */
export const useGetProjectModelDataDateRanges = (
  projectId: number | null,
  from?: Date | null,
  to?: Date | null,
  enabled: boolean = true
) => {
  const queryEnabled = !!projectId && !!from && !!to && enabled;

  const { data, isLoading, refetch } = useQuery<ProjectModelDataDateRange[]>({
    queryKey: [GET_PROJECT_MODEL_DATA_DATE_RANGES, projectId, from, to],
    queryFn: () => getProjectModelDataDateRanges(projectId!, from, to),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
    placeholderData: keepPreviousData,
  });

  return {
    modelDataDateRanges: queryEnabled ? data ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    refetch,
  };
};
